const getFeatureFlags = () => {
    const flagString = localStorage.getItem('ownersedge.app.featureFlags') || '{}';
    return JSON.parse(flagString);
};

export default { getFeatureFlags };
